import { render, staticRenderFns } from "./VxCurrencyInput.vue?vue&type=template&id=83eb79d8"
import script from "./VxCurrencyInput.vue?vue&type=script&lang=js"
export * from "./VxCurrencyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports